import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: '⬛', end: true },
  { to: '/admin/appointments', label: 'Appointments', icon: '📅' },
  { to: '/admin/reviews', label: 'Reviews', icon: '⭐' },
  { to: '/admin/gallery', label: 'Gallery', icon: '🖼' },
  { to: '/admin/services', label: 'Services', icon: '✂️' },
  { to: '/admin/offers', label: 'Special Offers', icon: '🎁' },
  { to: '/admin/settings', label: 'Site Settings', icon: '⚙️' },
];

export default function AdminLayout() {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar${sideOpen ? ' open' : ''}`}>
        <div className="admin-sidebar__header">
  <img
    src="/anns-logo.png"
    alt="ANN'S"
    className="admin-sidebar__logo-img"
  />
  <div>
    <span className="admin-sidebar__name">ANN'S Admin</span>
    <span className="admin-sidebar__sub">{admin?.email}</span>
  </div>
</div>
        <nav className="admin-sidebar__nav">
          {NAV.map(({ to, label, icon, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `admin-sidebar__link${isActive ? ' active' : ''}`}
              onClick={() => setSideOpen(false)}
            >
              <span className="admin-sidebar__link-icon">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>
        <button className="admin-sidebar__logout" onClick={handleLogout}>
          ↩ Sign Out
        </button>
      </aside>

      {/* Mobile overlay */}
      {sideOpen && <div className="admin-sidebar__overlay" onClick={() => setSideOpen(false)} />}

      {/* Main */}
      <div className="admin-main">
        <header className="admin-topbar">
          <button className="admin-topbar__menu" onClick={() => setSideOpen(v => !v)} aria-label="Toggle menu">☰</button>
          <span className="admin-topbar__title">ANN'S Beauty Parlour</span>
          <a href="/" target="_blank" rel="noreferrer" className="admin-topbar__view">View Site ↗</a>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
